module.exports = __webpack_public_path__ + "img/downsmallarrow.699ae216.svg";